import React, { useState } from "react";
import { FormControl, InputAdornment, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { PIVOTEL_DOMAINS, SEARCH_ICON } from "../../../utils/constants";
import CustomTextField from "../components/FormInputField";
import { ImagePath } from "../../../assets/ImagePath";

function ContactsSearchFunctional(props) {
  const [searchText, setSearchText] = useState("");
  const selectedDomain = useSelector((state) => state.domain.selectedDomain);

  const handleInputChange = (e) => {
    setSearchText(e.target.value);
    if (e.target.value === "") props.search("");
  };

  const search = (e) => {
    e.preventDefault();
    console.log(searchText);
    props.search(searchText);
  };

  const clearSearch = () => {
    setSearchText("");
    props.search("");
  };

  const getSelectedDomain = () => {
    let userDomain = selectedDomain?.userDomain;
    if (["vikand", "vikanduat"].includes(userDomain)) {
      return "Vikand";
    } else if (["onship"].includes(userDomain)) {
      return userDomain;
    } else if (PIVOTEL_DOMAINS.includes(userDomain)) {
      return "Pulsar";
    }
    return "FrontM";
  };

  const placeholderValue = `Search ${getSelectedDomain()} user and press enter`;

  const styles = {
    form: {
      width: "100%",
      backgroundColor: "#F3F3FA",
    },
    formContainer: {
      marginTop: "14px",
      height: "50px",
      width: "100%",
      borderRadius: "11px",
      backgroundColor: "#FFF",
      padding: "0 12px",
    },
    searchInput: {
      flexGrow: 1,
      height: "43px",
      fontSize: "14px",
      fontWeight: 300,
      color: "#8387BD",
      border: "0px solid #fff",
      backgroundColor: "#fff",
    },
    searchIcon: {
      width: "16px",
      height: "26px",
      marginRight: "5px",
    },
    iconCross: {
      fontWeight: "bold",
      fontSize: "16px",
      marginRight: "0.5rem",
    },
    iconMagnifier: {
      fontWeight: "bold",
      fontSize: "18px",
    },
  };

  return (
    <div className="" style={{ width: "100%", marginBottom: "0" }}>
      {props.parentComponent === "home" && (
        <form
          className="form-inline justify-content-center"
          onSubmit={search}
          style={styles.form}
        >
          <div
            className="w-full relative flex items-center mb-3 shadow-main-shd"
            style={props.containerStyle || styles.formContainer}
          >
            <input
              className={
                "form-control under-font h-[50px] !focus:outline-hidden !shadow-none !bg-transparent diff text-size-14 search-input border0 custom-placeholder placeholder:text-[#8387BD] w-full outline-none !pl-[28px]" +
                (props.textBoxStyle ? "contact-search-transparent" : "")
              }
              type="search"
              placeholder="Search"
              onChange={handleInputChange}
              value={searchText}
              style={props.textBoxStyle || styles.searchInput}
            />
            {searchText && searchText.length > 0 ? (
              <a
                className="bg-trans border0 "
                style={props.iconStyle || {}}
                onClick={clearSearch}
              >
                <span
                  aria-hidden="true"
                  className="icon-cross"
                  style={{
                    ...styles.iconCross,
                    color: props.iconStyle ? "#fff" : "#638DFF",
                  }}
                />
                
              </a>
            ) : (
              <button
                className="bg-trans border0 absolute left-[13px] top-[-9px] w-[19px]"
                type="submit"
                style={props.iconStyle || {}}
              >
                <span
                  aria-hidden="true"
                  className="icon-search"
                  style={styles.searchIcon}
                />
                <img src={ImagePath.searchMaind} alt="images" />
              </button>
            )}
          </div>
        </form>
      )}
      {props.parentComponent === "addNewContact" && (
        <form
          className="form-inline justify-content-center"
          onSubmit={search}
          style={{ width: "100%", padding: "12px 12px 0 12px" }}
        >
          <CustomTextField
            className="domain-lowercase"
            label={`${getSelectedDomain()} User`}
            placeholderValue={placeholderValue}
            value={searchText}
            handleInputChange={handleInputChange}
            EndAdornmentComponent={
              <InputAdornment position="end">
                {searchText && searchText.length > 0 ? (
                  <a
                    className="bg-trans border0"
                    style={props.iconStyle || {}}
                    onClick={clearSearch}
                  >
                    <span
                      aria-hidden="true"
                      className="icon-cross"
                      style={{
                        ...styles.iconCross,
                        color: props.iconStyle ? "#fff" : "#727484",
                      }}
                    />
                  </a>
                ) : (
                  <button
                    className="bg-trans border0"
                    type="submit"
                    style={props.iconStyle || {}}
                  >
                    <i
                      className="icon-magnifier"
                      style={{
                        ...styles.iconMagnifier,
                        color: props.iconStyle ? "#fff" : "#727484",
                      }}
                    />
                  </button>
                )}
              </InputAdornment>
            }
            {...props}
          />
        </form>
      )}
    </div>
  );
}

export default ContactsSearchFunctional;
